import React, { Component } from 'react';
import { Link, withRouter } from "react-router-dom";
import Pagination from "react-js-pagination";
import $ from 'jquery';
import {
  Row,
  Col,
  Modal,
  Table,
  OverlayTrigger,
  ButtonToolbar,
  Tooltip,
  Button
} from "react-bootstrap";

import { scrollToTopValidate,PageTitle } from "../Helpers/SettingHelper";
import Header from '../Layouts/Header';
import MenuSidebar from '../Layouts/MenuSidebar';
import { apiUrl} from'../Config/Config';
import axios from 'axios';
/* import { GET_DASHBOARDLIST  } from '../../actions'; */

class List extends Component {
  
  constructor(props)
  {
    super(props);
    this.state = {
      dashboardlist:'',
      totalRecordpackage:0,
      totalRecordnetworks:0,
      totalRecordCompanies:0,
      totalRecordUsers:0,
      totalRecordStores:0,      
      totalRecordAdscate:0,
      totalRecordAds:0,
      totalRecordTabs:0,
      totalRecordDashboardManage:0,
      totalRecordNotifications:0,
      totalRecordVehicles:0,
      totalRecordRaiseDispute:0,
      totalRecordMembershipCat:0,
      totalRecordMembership:0,
      totalRecordFaqCat:0,
      totalRecordFaq:0,
      totalRecordFonts:0,
      totalRecordTemplates:0,
      totalRecordPurchaseClicks:0,
    };
    
    var qs = require('qs');
    var admin_id = localStorage.getItem("admin_id");
    var loggedas = localStorage.getItem("loggedas");
    var postobject = {
    activePage: 1,
    search_all: '',
    admin_id: admin_id,
    loggedas: loggedas
    };

    axios.post(apiUrl+"dashboard/list",qs.stringify(postobject)).then(res => {
     
      if(res.data.status === 'success'){
        this.setState({ 
          totalRecordUsers : res.data.records_count_users,
          totalRecordCompanies : res.data.records_count_companies,
          totalRecordnetworks : res.data.records_count_network,
          totalRecordpackage : res.data.records_count_package,

          totalRecordStores : res.data.records_count_store,
          totalRecordAdscate : res.data.records_count_adscate,
          totalRecordAds : res.data.records_count_ads,
          totalRecordTabs : res.data.records_count_tabs,
          totalRecordDashboardManage : res.data.records_count_dashboard,
          totalRecordVehicles : res.data.records_count_vehicle,
          totalRecordNotifications : res.data.records_count_notification,
          totalRecordRaiseDispute : res.data.records_count_dispute,         
          totalRecordMembershipCat : res.data.records_count_membercat,
          totalRecordMembership : res.data.records_count_membership,
          totalRecordFaqCat : res.data.records_count_faqcat,
          totalRecordFaq : res.data.records_count_faq,
          totalRecordFonts : res.data.records_count_font,
          totalRecordTemplates : res.data.records_count_template,
          totalRecordPurchaseClicks : res.data.records_count_purchaseclick,

          });
      }
    }); 

    }

   
    componentDidMount() {
   }




  render() {
    return (
      <div className="wrapper"> 
 
    <Header />
    <MenuSidebar currentpage="dashboard" />
      
      <div className="content"> 
        <div className="content-wrapper">
              <div class="content-wrapper-before"></div>
              <div className="car-listing-wrap dashboard-wrap leaa-admin-head card">

                  <div className="title">
                    <h3>Dashboard</h3>
                  </div>

                  <div className="form-row first">

                        {/* <div className="form-left">
                        <div className="card pull-up border-top-info border-top-3 rounded-0">
                            <div className="card-header">
                                <h4 className="card-title card-badge">{this.state.totalRecordUsers}</h4>
                            </div>
                              <a  href="/user" className="">
                            <div className="card-content collapse show">
                                <div className="card-body p-1">
                                    <h4 className="font-large-1 text-bold-400 px-4">Users <i className="ft-users float-right"></i></h4>
                                </div>
                                <div className="card-footer p-1">
                                </div>
                            </div>
                       </a>
                    </div>
                          </div> */}

                        {/* {localStorage.getItem('admin_id') === '1' ?  <div className="form-right">
                            <div className="card pull-up border-top-info-red border-top-3 rounded-0">
                            <div className="card-header">
                                <h4 className="card-title card-badge-red card-title-red ">{this.state.totalRecordCompanies}</h4>
                            </div>
                              <a href="/company" className="">
                            <div className="card-content collapse show">
                                <div className="card-body p-1">
                                    <h4 className="font-large-1 text-bold-400 px-4">Companies<i className="ft-briefcase float-right"></i></h4>
                                </div>
                                <div className="card-footer p-1">
                                </div>
                            </div>
                       </a>
                    </div>
                          </div>: ''} */}
                    </div> 

                    <div className="form-row ">
            					<div className="form-left">
                        <div className="card pull-up border-top-info-black border-top-3 rounded-0">
                          <div className="card-header">
                            <h4 className="card-title card-badge-yellow card-title-black">{this.state.totalRecordpackage}</h4>
                          </div>
                          <a href="/package" className="">
                            <div className="card-content collapse show">
                                <div className="card-body p-1">
                                    <h4 className="font-large-1 text-bold-400 px-4">Packages<i className=" float-right"><svg width="32" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="7.49 8.17 83.03 81.65"><path class="st0" d="M90.513,57.595v21.488L71.904,89.827V68.339L90.513,57.595z M50.432,79.083l18.609,10.744V68.339L50.432,57.595  V79.083z M7.487,79.083l18.61,10.744V68.339L7.487,57.595V79.083z M49,8.173L30.82,18.669L49,29.165L67.18,18.67L49,8.173z   M28.96,89.827l18.609-10.744l0-21.488L28.96,68.339V89.827z M27.528,44.371L8.918,55.115l18.61,10.744l18.609-10.744L27.528,44.371  z M50.432,52.636l18.18-10.496l0-20.992l-18.18,10.496L50.432,52.636z M47.569,31.644L29.39,21.148V42.14l18.18,10.497V31.644z   M70.473,44.372L51.864,55.116L70.473,65.86l18.609-10.744L70.473,44.372z"/></svg></i>
                                    </h4>
                                </div>
                                
                            </div>
                          </a>
                        </div>   
            					</div>

                      <div className="form-right">
                        <div className="card pull-up border-top-info-black border-top-3 rounded-0">
                          <div className="card-header">
                            <h4 className="card-title card-badge card-title-black">{this.state.totalRecordUsers}</h4>
                          </div>
                          <a  href="/user" className="">
                            <div className="card-content collapse show">
                              <div className="card-body p-1">
                                <h4 className="font-large-1 text-bold-400 px-4">Users <i className="fa fa-users float-right"></i></h4>
                              </div>
                              <div className="card-footer p-1">
                              </div>
                            </div>
                          </a>
                        </div>
                      </div>

                      <div className="form-left">
                        <div className="card pull-up border-top-info-black border-top-3 rounded-0">
                          <div className="card-header">
                            <h4 className="card-title card-badge-purple card-title-black">{this.state.totalRecordnetworks}</h4>
                          </div>
                          <a href="/networks" className="">
                            <div className="card-content collapse show">
                              <div className="card-body p-1">
                                <h4 className="font-large-1 text-bold-400 px-4">Networks <i className="float-right"><svg width="32" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="2 2 20 20"><g><path d="M12,22A10,10,0,1,0,2,12,10,10,0,0,0,12,22Zm8-10a7.89,7.89,0,0,1-.8,3.46,23.31,23.31,0,0,0-2.4-.57A20.49,20.49,0,0,0,17,12a19.79,19.79,0,0,0-.15-2.48,22.14,22.14,0,0,0,2.48-.71A7.92,7.92,0,0,1,20,12Zm-5,0a17.46,17.46,0,0,1-.18,2.59,26.58,26.58,0,0,0-5.64,0A18.92,18.92,0,0,1,9,12a20,20,0,0,1,.12-2.12,23.23,23.23,0,0,0,2.88.2,23.23,23.23,0,0,0,2.88-.2A20,20,0,0,1,15,12ZM9.59,16.55a25.87,25.87,0,0,1,4.82,0C13.78,18.73,12.78,20,12,20S10.22,18.73,9.59,16.55Zm4.94-8.64a21.41,21.41,0,0,1-5.06,0C10.08,5.45,11.17,4,12,4S13.92,5.45,14.53,7.91Zm-7.33,7a23.31,23.31,0,0,0-2.4.57,7.9,7.9,0,0,1-.13-6.65,21.55,21.55,0,0,0,2.48.71A19.79,19.79,0,0,0,7,12,20.49,20.49,0,0,0,7.2,14.89ZM6,17.21c.53-.14,1.08-.26,1.64-.36a11.47,11.47,0,0,0,.85,2.3A7.73,7.73,0,0,1,6,17.21Zm9.61,1.94a11.47,11.47,0,0,0,.85-2.3c.56.1,1.11.22,1.64.36A7.73,7.73,0,0,1,15.56,19.15ZM18.28,7.06c-.58.19-1.17.35-1.77.49a12.36,12.36,0,0,0-1-2.7A8,8,0,0,1,18.28,7.06ZM8.44,4.85a12.36,12.36,0,0,0-.95,2.7c-.6-.14-1.19-.3-1.77-.49A8,8,0,0,1,8.44,4.85Z"/></g></svg></i></h4>
                              </div>
                              <div className="card-footer p-1">
                              </div>
                            </div>
                          </a>
                        </div>
                      </div>  
                      <div className="form-right">            					
                        <div className="card pull-up border-top-info-black border-top-3 rounded-0">
                            <div className="card-header">
                                <h4 className="card-title card-badge-yellow card-title-black">{this.state.totalRecordStores}</h4>
                            </div>
                              <a href="/stores" className="">
                                <div className="card-content collapse show">
                                    <div className="card-body p-1">
                                        <h4 className="font-large-1 text-bold-400 px-4">Stores<i className=" float-right"><svg width="32" xmlns="http://www.w3.org/2000/svg" version="1.1" x="0px" y="0px"  viewBox="5 11.38 90 77.23"><rect x="13.449" y="11.384" width="72.934" height="2.498"/><path d="M91.295,86.732c0,1.038-0.846,1.883-1.888,1.883H10.425c-1.042,0-1.888-0.845-1.888-1.883v-2.219  c0-1.046,0.846-1.891,1.888-1.891h78.982c1.042,0,1.888,0.845,1.888,1.891V86.732z"/><polygon points="14.824,16.878 5.166,33.861 18.653,33.861 25.48,16.878 "/><polygon points="35.138,16.878 30.308,33.861 43.631,33.861 45.628,16.878 "/><polygon points="85.343,16.878 95,33.861 81.513,33.861 74.686,16.878 "/><polygon points="65.026,16.878 69.854,33.861 56.535,33.861 54.538,16.878 "/><path d="M18.48,36.396c0,3.722-3.017,6.741-6.741,6.741l0,0C8.016,43.137,5,40.118,5,36.396H18.48z"/><path d="M43.623,36.396c0,3.722-3.017,6.741-6.74,6.741l0,0c-3.72,0-6.741-3.019-6.741-6.741H43.623z"/><path d="M69.69,36.396c0,3.722-3.019,6.741-6.74,6.741l0,0c-3.722,0-6.74-3.019-6.74-6.741H69.69z"/><path d="M94.833,36.396c0,3.722-3.017,6.741-6.741,6.741l0,0c-3.719,0-6.737-3.019-6.737-6.741H94.833z"/><path d="M88.092,44.645c-3.724,0-6.877-2.48-7.898-5.876H70.85c-1.022,3.396-4.176,5.876-7.899,5.876  c-3.726,0-6.878-2.48-7.899-5.876H44.783c-1.021,3.396-4.174,5.876-7.9,5.876c-3.725,0-6.877-2.48-7.899-5.876H19.64  c-1.022,3.396-4.175,5.876-7.9,5.876c-0.978,0-1.914-0.18-2.786-0.493v33.939c0,1.041,0.846,1.888,1.888,1.888h78.149  c1.042,0,1.888-0.847,1.888-1.888V44.15C90.007,44.464,89.071,44.645,88.092,44.645z M59.414,78.077H40.419V56.882  c0-3.186,2.583-5.768,5.768-5.768h7.459c3.186,0,5.768,2.582,5.768,5.768V78.077z"/></svg></i></h4>
                                    </div>
                                    <div className="card-footer p-1">
                                    </div>
                                </div>
                          </a>
                        </div>   
            					</div>                     
            					<div className="form-left">
                        <div className="card pull-up border-top-info-black border-top-3 rounded-0">
                          <div className="card-header">
                            <h4 className="card-title card-badge-purple card-title-black">{this.state.totalRecordAdscate}</h4>
                          </div>
                          <a href="/adsCategory" className="">
                            <div className="card-content collapse show">
                                <div className="card-body p-1">
                                    <h4 className="font-large-1 text-bold-400 px-4">Ads Categories <i className="float-right"><svg width="32" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="15 18.4 69.95 62.99">  <path d="m16.699 55.898c0.69922 3.6992 3.8984 6.3008 7.6016 6.3008 0.5 0 0.89844 0 1.3008-0.10156l15.898-2.8984c0.39844-0.10156 26.102 7.6992 26.102 7.6992 0.19922 0.10156 0.39844 0.10156 0.59766 0.10156 0.39844 0 0.69922-0.10156 1-0.39844 0.39844-0.39844 0.60156-0.89844 0.5-1.5l-8.1016-45.398c-0.10156-0.5-0.5-1-1-1.1992-0.5-0.19922-1.1016-0.10156-1.5 0.30078 0 0-21.398 16.199-21.801 16.199l-15.898 2.9961c-2 0.39844-3.8008 1.5-5 3.1992-1.1992 1.6992-1.6016 3.6992-1.3008 5.8008zm2.1016-13c0.69922-1 1.8008-1.6992 3-2 0.5-0.10156 1.1016 0.30078 1.1992 0.80078 0.10156 0.5-0.30078 1.1016-0.80078 1.1992-0.69922 0.10156-1.3008 0.5-1.8008 1.1016-0.39844 0.60156-0.60156 1.3008-0.39844 2l0.5 2.6992c0.10156 0.60156-0.30078 1.1016-0.80078 1.1992h-0.19922c-0.5 0-0.89844-0.30078-1-0.80078l-0.5-2.6992c-0.10156-1.2969 0.10156-2.5 0.80078-3.5z"/>  <path d="m35.898 63.398-5.3008 0.89844-3.1016 0.60156 4.8008 11.699c1.1992 3 3.6992 4.8008 6.3984 4.8008 0.30078 0 0.60156 0 1-0.10156l4.6016-0.80078c0.5-0.10156 0.89844-0.39844 1.1016-0.80078 0.19922-0.39844 0.30078-0.89844 0.10156-1.3008l-6.5-15.496z"/>  <path d="m71.602 43h0.30078l10-1.8008c0.80078-0.19922 1.3984-1 1.1992-1.8008-0.19922-0.80078-1-1.3984-1.8008-1.1992l-10 1.8008c-0.80078 0.19922-1.3984 1-1.1992 1.8008 0.19922 0.59766 0.79688 1.1992 1.5 1.1992z"/>  <path d="m73.398 52.398c-0.80078-0.19922-1.6992 0.19922-1.8984 1.1016-0.19922 0.80078 0.19922 1.6992 1.1016 1.8984l10.398 2.9023c0.10156 0 0.30078 0.10156 0.39844 0.10156 0.69922 0 1.3008-0.39844 1.5-1.1016 0.19922-0.80078-0.19922-1.6992-1.1016-1.8984z"/>  <path d="m78.602 21.898c-0.5-0.69922-1.5-0.80078-2.1992-0.30078l-8.8008 6.4023c-0.69922 0.5-0.80078 1.5-0.30078 2.1992 0.30078 0.39844 0.80078 0.60156 1.3008 0.60156 0.30078 0 0.60156-0.10156 0.89844-0.30078l8.8008-6.3984c0.69922-0.5 0.80078-1.5 0.30078-2.2031z"/> </svg></i></h4>
                                </div>
                                
                            </div>
                          </a>
                        </div>
            					</div> 

                      <div className="form-right">
                        <div className="card pull-up border-top-info-black border-top-3 rounded-0">
                          <div className="card-header">
                              <h4 className="card-title card-badge card-title-black">{this.state.totalRecordAds}</h4>
                          </div>
                          <a  href="/advertisement" className="">
                            <div className="card-content collapse show">
                                <div className="card-body p-1">
                                    <h4 className="font-large-1 text-bold-400 px-4">Advertisement<i className="float-right"><svg width="32" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="15 18.4 69.95 62.99">  <path d="m16.699 55.898c0.69922 3.6992 3.8984 6.3008 7.6016 6.3008 0.5 0 0.89844 0 1.3008-0.10156l15.898-2.8984c0.39844-0.10156 26.102 7.6992 26.102 7.6992 0.19922 0.10156 0.39844 0.10156 0.59766 0.10156 0.39844 0 0.69922-0.10156 1-0.39844 0.39844-0.39844 0.60156-0.89844 0.5-1.5l-8.1016-45.398c-0.10156-0.5-0.5-1-1-1.1992-0.5-0.19922-1.1016-0.10156-1.5 0.30078 0 0-21.398 16.199-21.801 16.199l-15.898 2.9961c-2 0.39844-3.8008 1.5-5 3.1992-1.1992 1.6992-1.6016 3.6992-1.3008 5.8008zm2.1016-13c0.69922-1 1.8008-1.6992 3-2 0.5-0.10156 1.1016 0.30078 1.1992 0.80078 0.10156 0.5-0.30078 1.1016-0.80078 1.1992-0.69922 0.10156-1.3008 0.5-1.8008 1.1016-0.39844 0.60156-0.60156 1.3008-0.39844 2l0.5 2.6992c0.10156 0.60156-0.30078 1.1016-0.80078 1.1992h-0.19922c-0.5 0-0.89844-0.30078-1-0.80078l-0.5-2.6992c-0.10156-1.2969 0.10156-2.5 0.80078-3.5z"/>  <path d="m35.898 63.398-5.3008 0.89844-3.1016 0.60156 4.8008 11.699c1.1992 3 3.6992 4.8008 6.3984 4.8008 0.30078 0 0.60156 0 1-0.10156l4.6016-0.80078c0.5-0.10156 0.89844-0.39844 1.1016-0.80078 0.19922-0.39844 0.30078-0.89844 0.10156-1.3008l-6.5-15.496z"/>  <path d="m71.602 43h0.30078l10-1.8008c0.80078-0.19922 1.3984-1 1.1992-1.8008-0.19922-0.80078-1-1.3984-1.8008-1.1992l-10 1.8008c-0.80078 0.19922-1.3984 1-1.1992 1.8008 0.19922 0.59766 0.79688 1.1992 1.5 1.1992z"/>  <path d="m73.398 52.398c-0.80078-0.19922-1.6992 0.19922-1.8984 1.1016-0.19922 0.80078 0.19922 1.6992 1.1016 1.8984l10.398 2.9023c0.10156 0 0.30078 0.10156 0.39844 0.10156 0.69922 0 1.3008-0.39844 1.5-1.1016 0.19922-0.80078-0.19922-1.6992-1.1016-1.8984z"/>  <path d="m78.602 21.898c-0.5-0.69922-1.5-0.80078-2.1992-0.30078l-8.8008 6.4023c-0.69922 0.5-0.80078 1.5-0.30078 2.1992 0.30078 0.39844 0.80078 0.60156 1.3008 0.60156 0.30078 0 0.60156-0.10156 0.89844-0.30078l8.8008-6.3984c0.69922-0.5 0.80078-1.5 0.30078-2.2031z"/> </svg></i></h4>
                                </div>
                                
                            </div>
                          </a>
                        </div>
                      </div>
                      <div className="form-left">
                        <div className="card pull-up border-top-info-black border-top-3 rounded-0">
                          <div className="card-header">
                            <h4 className="card-title card-badge-purple card-title-black">{this.state.totalRecordFaqCat}</h4>
                          </div>
                          <a href="/Faqcategory" className="">
                            <div className="card-content collapse show">
                                <div className="card-body p-1">
                                    <h4 className="font-large-1 text-bold-400 px-4">Faq Category <i className="float-right"><svg width="40" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="5.08 5.08 89.85 89.84">  <path d="m86.215 24.934h-8.875c-0.86719 1.1328-1.9219 2.1875-3.1133 3.2188-0.75391 0.65234-3.6445 2.8203-3.6445 3.8906v1.5156c0 2.5586-1.4922 4.7695-3.6562 5.8125 2.7031 1.1016 4.6133 3.7578 4.6133 6.8555 0 4.0859-3.3125 7.3984-7.3984 7.3984s-7.3984-3.3125-7.3984-7.3984c0-3.1016 1.9062-5.7539 4.6133-6.8555-2.1641-1.0391-3.6562-3.2539-3.6562-5.8125v-1.5156c0-2.8555 0.84766-5.1172 2.2578-7.1133h-16.305c-4.7891 0-8.707 3.918-8.707 8.707v13.234h11.539c5.5898 0 10.156 4.5625 10.156 10.156v10.492h10.488l12.562 13.051v-13.051h6.5312c4.7891 0 8.707-3.918 8.707-8.707v-25.172c0-4.7891-3.918-8.707-8.707-8.707zm-74.105 25.066h34.371c3.8672 0 7.0312 3.1641 7.0312 7.0312v20.324c0 3.8672-3.1641 7.0312-7.0312 7.0312h-18.953l-10.141 10.539v-10.539h-5.2734c-3.8672 0-7.0312-3.1641-7.0312-7.0312v-20.324c0-3.8672 3.1641-7.0312 7.0312-7.0312zm31.207 9.8984c0.86328 0 1.5625 0.69922 1.5625 1.5625 0 0.86328-0.69922 1.5625-1.5625 1.5625h-28.047c-0.86328 0-1.5625-0.69922-1.5625-1.5625 0-0.86328 0.69922-1.5625 1.5625-1.5625zm0 11.461c0.86328 0 1.5625 0.69922 1.5625 1.5625s-0.69922 1.5625-1.5625 1.5625h-28.047c-0.86328 0-1.5625-0.69922-1.5625-1.5625s0.69922-1.5625 1.5625-1.5625zm20.82-29.406c2.3594 0 4.2734 1.9141 4.2734 4.2734 0 2.3594-1.9141 4.2734-4.2734 4.2734s-4.2734-1.9141-4.2734-4.2734c0-2.3594 1.9141-4.2734 4.2734-4.2734zm0.79297-30.234c-2.9453 0-5.332 2.3867-5.332 5.332 0 1.832-1.4883 3.3203-3.3203 3.3203-1.832 0-3.3203-1.4883-3.3203-3.3203 0-6.6094 5.3594-11.969 11.969-11.969s11.969 5.3594 11.969 11.969c0 8.4727-9.4414 9.8516-9.4414 15v1.5156c0 1.832-1.4883 3.3203-3.3203 3.3203-1.832 0-3.3203-1.4883-3.3203-3.3203v-1.5156c0-8.1055 9.4414-9.6562 9.4414-15 0-2.9453-2.3867-5.332-5.332-5.332z" fillRule="evenodd"></path> </svg></i></h4>
                                </div>
                                
                            </div>
                          </a>
                        </div>
            					</div> 
                      <div className="form-right">
                        <div className="card pull-up border-top-info-black border-top-3 rounded-0">
                            <div className="card-header">
                                <h4 className="card-title card-badge card-title-black">{this.state.totalRecordFaq}</h4>
                            </div>
                              <a href="/Faq" className="">
                                <div className="card-content collapse show">
                                    <div className="card-body p-1">
                                        <h4 className="font-large-1 text-bold-400 px-4">Faq<i className="float-right"><svg width="40" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="5.08 5.08 89.85 89.84">  <path d="m86.215 24.934h-8.875c-0.86719 1.1328-1.9219 2.1875-3.1133 3.2188-0.75391 0.65234-3.6445 2.8203-3.6445 3.8906v1.5156c0 2.5586-1.4922 4.7695-3.6562 5.8125 2.7031 1.1016 4.6133 3.7578 4.6133 6.8555 0 4.0859-3.3125 7.3984-7.3984 7.3984s-7.3984-3.3125-7.3984-7.3984c0-3.1016 1.9062-5.7539 4.6133-6.8555-2.1641-1.0391-3.6562-3.2539-3.6562-5.8125v-1.5156c0-2.8555 0.84766-5.1172 2.2578-7.1133h-16.305c-4.7891 0-8.707 3.918-8.707 8.707v13.234h11.539c5.5898 0 10.156 4.5625 10.156 10.156v10.492h10.488l12.562 13.051v-13.051h6.5312c4.7891 0 8.707-3.918 8.707-8.707v-25.172c0-4.7891-3.918-8.707-8.707-8.707zm-74.105 25.066h34.371c3.8672 0 7.0312 3.1641 7.0312 7.0312v20.324c0 3.8672-3.1641 7.0312-7.0312 7.0312h-18.953l-10.141 10.539v-10.539h-5.2734c-3.8672 0-7.0312-3.1641-7.0312-7.0312v-20.324c0-3.8672 3.1641-7.0312 7.0312-7.0312zm31.207 9.8984c0.86328 0 1.5625 0.69922 1.5625 1.5625 0 0.86328-0.69922 1.5625-1.5625 1.5625h-28.047c-0.86328 0-1.5625-0.69922-1.5625-1.5625 0-0.86328 0.69922-1.5625 1.5625-1.5625zm0 11.461c0.86328 0 1.5625 0.69922 1.5625 1.5625s-0.69922 1.5625-1.5625 1.5625h-28.047c-0.86328 0-1.5625-0.69922-1.5625-1.5625s0.69922-1.5625 1.5625-1.5625zm20.82-29.406c2.3594 0 4.2734 1.9141 4.2734 4.2734 0 2.3594-1.9141 4.2734-4.2734 4.2734s-4.2734-1.9141-4.2734-4.2734c0-2.3594 1.9141-4.2734 4.2734-4.2734zm0.79297-30.234c-2.9453 0-5.332 2.3867-5.332 5.332 0 1.832-1.4883 3.3203-3.3203 3.3203-1.832 0-3.3203-1.4883-3.3203-3.3203 0-6.6094 5.3594-11.969 11.969-11.969s11.969 5.3594 11.969 11.969c0 8.4727-9.4414 9.8516-9.4414 15v1.5156c0 1.832-1.4883 3.3203-3.3203 3.3203-1.832 0-3.3203-1.4883-3.3203-3.3203v-1.5156c0-8.1055 9.4414-9.6562 9.4414-15 0-2.9453-2.3867-5.332-5.332-5.332z" fillRule="evenodd"></path> </svg></i></h4>
                                    </div>
                                    <div className="card-footer p-1">
                                    </div>
                                </div>
                          </a>
                        </div>   
            					</div>
                      <div className="form-left">
                        <div className="card pull-up border-top-info-black border-top-3 rounded-0">
                          <div className="card-header">
                            <h4 className="card-title card-badge-purple card-title-black">{this.state.totalRecordFonts}</h4>
                          </div>
                          <a href="/fonts" className="">
                            <div className="card-content collapse show">
                                <div className="card-body p-1">
                                    <h4 className="font-large-1 text-bold-400 px-4">Fonts <i className="fa fa-font float-right"></i></h4>
                                </div>
                                
                            </div>
                          </a>
                        </div>
            					</div> 
                      <div className="form-right">
                        <div className="card pull-up border-top-info-black border-top-3 rounded-0">
                            <div className="card-header">
                                <h4 className="card-title card-badge card-title-black">{this.state.totalRecordTemplates}</h4>
                            </div>
                              <a href="/templates" className="">
                                <div className="card-content collapse show">
                                    <div className="card-body p-1">
                                        <h4 className="font-large-1 text-bold-400 px-4">Templates<i className="float-right"><svg width="32" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="7.81 7.81 84.38 84.37">  <path d="m12.5 45.312h28.125c2.5898 0 4.6875 2.5898 4.6875 4.6875v37.5c0 2.5898-2.0977 4.6875-4.6875 4.6875h-28.125c-2.5898 0-4.6875-2.5898-4.6875-4.6875v-37.5c0-2.5898 2.0977-4.6875 4.6875-4.6875z"/>  <path d="m12.5 7.8125h28.125c2.5898 0 4.6875 2.5898 4.6875 4.6875v18.75c0 2.5898-2.0977 4.6875-4.6875 4.6875h-28.125c-2.5898 0-4.6875-2.5898-4.6875-4.6875v-18.75c0-2.5898 2.0977-4.6875 4.6875-4.6875z"/>  <path d="m59.375 64.062h28.125c2.5898 0 4.6875 2.5898 4.6875 4.6875v18.75c0 2.5898-2.0977 4.6875-4.6875 4.6875h-28.125c-2.5898 0-4.6875-2.5898-4.6875-4.6875v-18.75c0-2.5898 2.0977-4.6875 4.6875-4.6875z"/>  <path d="m59.375 7.8125h28.125c2.5898 0 4.6875 2.5898 4.6875 4.6875v37.5c0 2.5898-2.0977 4.6875-4.6875 4.6875h-28.125c-2.5898 0-4.6875-2.5898-4.6875-4.6875v-37.5c0-2.5898 2.0977-4.6875 4.6875-4.6875z"/> </svg></i></h4>
                                    </div>
                                    <div className="card-footer p-1">
                                    </div>
                                </div>
                          </a>
                        </div>   
            					</div>   

                      <div className="form-left">
                        <div className="card pull-up border-top-info-black border-top-3 rounded-0">
                          <div className="card-header">
                            <h4 className="card-title card-badge-purple card-title-black">{this.state.totalRecordNotifications}</h4>
                          </div>
                          <a href="/notifications" className="">
                            <div className="card-content collapse show">
                                <div className="card-body p-1">
                                    <h4 className="font-large-1 text-bold-400 px-4">Notifications <i className="fa fa-bell float-right"></i></h4>
                                </div>
                                
                            </div>
                          </a>
                        </div>
            					</div>   
                      <div className="form-right">
                        <div className="card pull-up border-top-info-black border-top-3 rounded-0">
                          <div className="card-header">
                              <h4 className="card-title card-badge card-title-black">{this.state.totalRecordPurchaseClicks}</h4>
                          </div>
                          <a  href="/purchasehistory" className="">
                            <div className="card-content collapse show">
                                <div className="card-body p-1">
                                    <h4 className="font-large-1 text-bold-400 px-4">Purchase Clicks<i className="fa fa-check float-right"></i></h4>
                                </div>
                                
                            </div>
                          </a>
                        </div>
                      </div>
            				</div>
                   
                    {/* <div className="form-row ">
                      <div className="form-left">
                        <div className="card pull-up border-top-info border-top-3 rounded-0">
                          <div className="card-header">
                              <h4 className="card-title card-badge">{this.state.totalRecordDashboardManage}</h4>
                          </div>
                          <a  href="/dashboardmanagement" className="">
                            <div className="card-content collapse show">
                                <div className="card-body p-1">
                                    <h4 className="font-large-1 text-bold-400 px-4">Dashboard Management <i className="ft-users float-right"></i></h4>
                                </div>
                                <div className="card-footer p-1">
                                </div>
                            </div>
                          </a>
                        </div>
                      </div>
                      <div className="form-right">
                         <div className="card pull-up border-top-info-black border-top-3 rounded-0">
                            <div className="card-header">
                            <h4 className="card-title card-badge card-title-black">{this.state.totalRecordTabs}</h4>
                             </div>
                              <a href="/tabmanagement" className="">
                                <div className="card-content collapse show">
                                    <div className="card-body p-1">
                                        <h4 className="font-large-1 text-bold-400 px-4">Tab Management <i className="ft-users float-right"></i></h4>
                                    </div>
                                    <div className="card-footer p-1">
                                    </div>
                                </div>
                            </a>
                          </div>
            					  </div> 
                                                   					
            				</div> */}

                    {/* <div className="form-row ">
                      <div className="form-left">
                        <div className="card pull-up border-top-info border-top-3 rounded-0">
                          <div className="card-header">
                              <h4 className="card-title card-badge">{this.state.totalRecordVehicles}</h4>
                          </div>
                          <a  href="/vehicles" className="">
                            <div className="card-content collapse show">
                                <div className="card-body p-1">
                                    <h4 className="font-large-1 text-bold-400 px-4">Vehicles <i className="ft-users float-right"></i></h4>
                                </div>
                                <div className="card-footer p-1">
                                </div>
                            </div>
                          </a>
                        </div>
                      </div>
                      <div className="form-right">
                        <div className="card pull-up border-top-info-purple border-top-3 rounded-0">
                          <div className="card-header">
                            <h4 className="card-title card-badge-purple card-title-purple">{this.state.totalRecordRaiseDispute}</h4>
                          </div>
                          <a href="/raiseDispute" className="">
                            <div className="card-content collapse show">
                                <div className="card-body p-1">
                                    <h4 className="font-large-1 text-bold-400 px-4">Raise Dispute <i className="ft-users float-right"></i></h4>
                                </div>
                                <div className="card-footer p-1">
                                </div>
                            </div>
                          </a>
                        </div>
            					</div>                                 					
            				</div> */}

                    <div className="form-row ">
                      
                      {/* <div className="form-right">
                        <div className="card pull-up border-top-info-purple border-top-3 rounded-0">
                          <div className="card-header">
                            <h4 className="card-title card-badge-purple card-title-purple">{this.state.totalRecordMembershipCat}</h4>
                          </div>
                          <a href="/membershipcategory" className="">
                            <div className="card-content collapse show">
                                <div className="card-body p-1">
                                    <h4 className="font-large-1 text-bold-400 px-4">Membership Category <i className="ft-users float-right"></i></h4>
                                </div>
                                <div className="card-footer p-1">
                                </div>
                            </div>
                          </a>
                        </div>
            					</div>                                 					 */}
            				</div> 

                      
                </div>
          </div>  
      </div>
      
    </div>
    );
  }
}


export default List;